module.exports = __webpack_public_path__ + "static/media/kotlin.61ab98ab.png";